import { useCart } from "@shopify/hydrogen/client";

import { useCartUI } from "../../hooks/use-cart-ui";
import { useMode } from "../../hooks/use-mode";
import { CartIcon } from "./CartIcon";

const DEFAULT_CLASSES =
  "block m-0 w-full items-center justify-center uppercase font-medium text-center px-6 py-4 rounded-md disabled:border-neutral-300 disabled:bg-neutral-300 disabled:cursor-not-allowed";

const VARIANT_CLASSES = {
  primary: "text-white bg-black hover:bg-neutral-900 active:bg-neutral-700",
  secondary:
    "bg-white hover:bg-neutral-50 active:bg-neutral-100 border border-black",
};

export const BUTTON_PRIMARY_CLASSES = `${DEFAULT_CLASSES} ${VARIANT_CLASSES.primary}`;
export const BUTTON_SECONDARY_CLASSES = `${DEFAULT_CLASSES} ${VARIANT_CLASSES.secondary}`;

export function CartIconWithItemsButton(props: { onPause?: () => void }) {
  const { onPause } = props;

  const { lines } = useCart();

  const mode = useMode();

  const totalQuantity = lines?.reduce((acc, line) => acc + line.quantity, 0);

  const { toggleCart } = useCartUI();

  if (totalQuantity === 0) {
    return null;
  }

  return (
    <button
      type="button"
      tabIndex={0}
      data-test-id="cart-icon-with-items-button"
      className="lookbook--story--cart-icon"
      onClick={() => {
        toggleCart();
        onPause?.();
      }}>
      <CartIcon />
      <span
        className="lookbook--story--cart-icon--quantity"
        style={{ color: mode === "desktop" ? "#1F2937" : "#fff" }}>
        {totalQuantity}
      </span>
    </button>
  );
}
